import { useEffect } from 'react';
import { useFeatureToggle } from '../../../../../hooks/useFeatureToggle';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';

export default function useCheckUserBeautiesBalance() {
  const callbacks = useApplicationCallbacks();

  const gameTamagotchiBeauties = useFeatureToggle('gameTamagotchiBeauties');

  useEffect(() => {
    if (!gameTamagotchiBeauties) return;
    callbacks.getBeautiesBalance();
  }, []);
}
